exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2JhxsatQfr_NsCNsg6rjWy textarea{\n    min-height: 400px;\n}", ""]);

// exports
exports.locals = {
	"container": "_2JhxsatQfr_NsCNsg6rjWy"
};